import { createEntityMetadataMap } from '@mri-platform/shared/entity';
import { Client, ClientSummary } from '../models';

export const entityMetadata = createEntityMetadataMap(Client, ClientSummary);
